<template>
  <i class="fa fa-fw fa-twitter"></i>
</template>

<script>
export default {
  name: 'Twitter',
};
</script>

<style scoped>
.fa-twitter {
  color: #1da1f2;
}
</style>





// WEBPACK FOOTER //
// TwitterIcon.vue?3d01f4c3